import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DOC_TYPE_LABELS = {
  receipt: { ar: 'وصل عملية يومية', icon: '🧾' },
  invoice: { ar: 'فاتورة رسمية', icon: '📄' },
  installment_receipt: { ar: 'جدول أقساط', icon: '📋' },
  ticket: { ar: 'تذكرة طيران', icon: '🎫' },
  umrah_contract: { ar: 'عقد عمرة', icon: '📜' },
};

const VerifyDocument = () => {
  const { docId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/verify/${docId}`);
        setData(r.data);
      } catch (e) {
        setData({ verified: false, message: '❌ تعذر الاتصال بالخادم.' });
      } finally {
        setLoading(false);
      }
    })();
  }, [docId]);

  const verified = data?.verified;
  const labels = DOC_TYPE_LABELS[data?.doc_type] || { ar: 'وثيقة', icon: '📃' };

  return (
    <div
      dir="rtl"
      className="min-h-screen flex items-center justify-center px-4 py-10"
      style={{
        background:
          'linear-gradient(135deg, #18181B 0%, #1A1A1A 50%, #27272A 100%)',
      }}
      data-testid="verify-doc-page"
    >
      <div className="w-full max-w-xl bg-white rounded-3xl shadow-2xl overflow-hidden">
        {/* Top gold bar */}
        <div
          className="h-2"
          style={{
            background:
              'linear-gradient(90deg, #B8941F 0%, #D4AF37 50%, #F4DD75 100%)',
          }}
        />

        {/* Header */}
        <div className="text-center px-8 pt-8 pb-4">
          <div className="text-5xl font-black mb-2" style={{ color: '#D4AF37' }}>
            صنهاجة سفر
          </div>
          <div className="text-noir-500 text-sm tracking-widest">SANHAJA SAFARI</div>
        </div>

        {loading ? (
          <div className="p-12 text-center text-noir-500">جاري التحقق...</div>
        ) : verified ? (
          <div className="px-8 py-6">
            {/* Status badge */}
            <div className="text-center mb-6">
              <div className="inline-flex items-center gap-2 bg-emerald-50 border-2 border-emerald-300 text-emerald-800 px-6 py-3 rounded-full text-lg font-bold">
                <span className="text-2xl">✅</span>
                وثيقة أصلية ومُعتَمَدة
              </div>
            </div>

            {/* Doc type icon */}
            <div className="text-center mb-4">
              <div className="text-6xl mb-2">{labels.icon}</div>
              <div className="text-xl font-bold text-noir-900">{labels.ar}</div>
            </div>

            {/* Details */}
            <div className="bg-brand-50 border border-brand-200 rounded-2xl p-5 space-y-3">
              {data.number && (
                <Row label="رقم الوثيقة" value={data.number} mono />
              )}
              {data.date && (
                <Row label="التاريخ" value={String(data.date).slice(0, 10)} />
              )}
              {data.client_name && (
                <Row label="الزبون" value={data.client_name} />
              )}
              {data.service_name && (
                <Row label="الخدمة" value={data.service_name} />
              )}
              {data.amount != null && (
                <Row
                  label="المبلغ"
                  value={`${Number(data.amount).toLocaleString('en-US')} دج`}
                  highlight
                />
              )}
              {data.issued_by && (
                <Row label="الصادرة عن" value={data.issued_by} />
              )}
            </div>

            <div className="text-center text-xs text-noir-500 mt-6">
              تم التحقق في {String(data.verified_at).slice(0, 19).replace('T', ' ')}
            </div>
          </div>
        ) : (
          <div className="px-8 py-10 text-center">
            <div className="text-7xl mb-4">⚠️</div>
            <h2 className="text-2xl font-bold text-red-700 mb-2">
              وثيقة غير صالحة
            </h2>
            <p className="text-noir-600 leading-relaxed">{data?.message}</p>
            <p className="text-noir-400 text-xs mt-6">
              قد تكون الوثيقة مزوّرة أو محذوفة من سجلاتنا. يُرجى التواصل مع
              الوكالة للتأكد.
            </p>
          </div>
        )}

        {/* Footer */}
        <div className="bg-noir-900 text-brand-300 px-8 py-4 text-center text-xs">
          © {new Date().getFullYear()} وكالات صنهاجة للسفر — Royal Gold Edition
          <br />
          <span className="opacity-60">
            هذه الصفحة عامة — لا تتطلّب تسجيل دخول. مسحت QR على الوثيقة الأصلية.
          </span>
        </div>
      </div>
    </div>
  );
};

const Row = ({ label, value, mono = false, highlight = false }) => (
  <div className="flex items-center justify-between gap-3 border-b border-brand-200 pb-2 last:border-0 last:pb-0">
    <span className="text-noir-600 text-sm">{label}:</span>
    <span
      className={`${mono ? 'font-mono' : 'font-semibold'} ${
        highlight ? 'text-xl text-brand-700' : 'text-noir-900'
      } text-end`}
    >
      {value}
    </span>
  </div>
);

export default VerifyDocument;
